import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Container from '../../components/Container';
import Section from '../../components/Section';
import CardWrapper from "../../components/CardWrapper";
import Enterprise from "../../components/Enterprise";
import PropTypes from 'prop-types';

moment.locale('nl');

const Prices = ({
                  head,
                }) => {
  const title = (head.metaTitle ? head.metaTitle : head.title);

  const link = [
    {rel: "canonical", href: "https://www.postcodeapi.nu/prijzen"},
  ];

  return (
    <div className="prices">
      <Helmet
        title={title + ' | Postcode API'}
        meta={[
          {name: "description", content: head.description},
          {property: "og:type", content: "article"},
          {property: "og:title", content: title},
          {property: "og:description", content: head.description},
          {property: "og:site_name", content: "Postcode API"},
          {property: "og:url", content: "https://www.postcodeapi.nu/prijzen"},
          {
            property: "og:image",
            content: "https://www.postcodeapi.nu" + (head.headerImage ? head.headerImage : "/assets/logo/share-logo.png")
          },
          {property: "fb:app_id", content: "254153114996381"},
        ]}
        link={link}
      />
      <header/>
      <Section className="hasPullUp" sectionBrand sectionCenter>
        <Container>
          <div className="intro">
            <h2 className="heading heading-white">Kies je pakket</h2>
            <p>
              Een abonnement op Postcode API is per maand of per jaar af te sluiten. Je betaalt per creditcard of automatische incasso, bij een
              jaarabonnement kun je ook per factuur betalen. Bovendien krijg je bij een jaarabonnement 5% korting. Wil je de API liever eerst uitproberen? <Link to="/gratis-proberen" className="introLink">Vraag dan een gratis API key aan</Link>.
            </p>
          </div>
        </Container>
      </Section>
      <Section className="hasPullUp" sectionSkewRight sectionSecondary>
        <Container>
          <div className="pullUp">
            <CardWrapper/>
          </div>
        </Container>
      </Section>
      <Section className="hasPullUpSmall" sectionSkewRight>
        <Container>
          <div id="enterprise" className="pullUp">
            <Enterprise/>
          </div>
        </Container>
      </Section>
    </div>
  );
};

Prices.propTypes = {
  head: PropTypes.object.isRequired
};

export default Prices;
